// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__QhnBO","wrapper":"_styles_wrapper__ygpef"};